module.exports = __webpack_public_path__ + "img/debts_bobocoin.gm.34815f6.png";